/* eslint-disable react-hooks/exhaustive-deps */
// React
import { useCallback, useEffect, useRef, useState } from "react";

// Router
import { useLocation, useNavigate } from "react-router-dom";

// Redux
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategories,
  uploadFile,
} from "../../../redux/features/sharedResources/sharedResources";

import { reimbursementTxnRequest } from "../../../redux/features/reimbursementTransaction";

// Utils
import ICONS from "../../../assets/Icons";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../utils/configurationProvider";

// Components
import AmountToWords from "../../../components/_utils/AmountToWords";
import PrimaryStepper from "../../../components/_utils/CommonSteppers/PrimaryStepper";
import SVGComponent from "../../../components/_utils/SVGComponent";
import ReimbursementRequestAccount from "../../../components/ReimbursementRequest/ReimbursementRequestAccount";
import ReimbursementRequestTxnAdditionalDetails from "../../../components/ReimbursementRequest/ReimbursementRequestTxnAdditionalDetails";
import ReimbursementRequestTxnConfirm from "../../../components/ReimbursementRequest/ReimbursementRequestTxnConfirm";
import ReimbursementRequestTxnTransferAmount from "../../../components/ReimbursementRequest/ReimbursementRequestTxnTransferAmount";

import "./index.css";

const ReimbursementTxnRequestCreate = () => {
  //  useDispatch, useNavigate, useLocation
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  //  useRef
  const scrollIt = useRef(null);
  //  useState
  const [endDate, setEndDate] = useState({});
  const [quantity, setQuantity] = useState({});
  const [timeData, setTimeData] = useState({});
  const [startDate, setStartDate] = useState({});
  const [mapingCat, setMapingCat] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [hyperLinks, setHyperLinks] = useState({});
  const [quantities, setQuantities] = useState({});
  const [direction, setDirection] = useState(null);
  const [catSelect, setCatSelect] = useState(false);
  const [startDateCal, setStartDateCal] = useState({});
  const [showYearDrop, setShowYearDrop] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [amountInWords, setAmountInWords] = useState("");
  const [selectedValue, setSelectedValue] = useState({});
  const [additionalData, setAdditionalData] = useState({});
  const [removeClassName, setRemoveClassName] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [nextButtonEnabled, BenEnableNextButton] = useState(true);
  const [isCategoryLoading, setIsCategoryLoading] = useState(false);
  const [selectedValueMonth, setSelectedValueMonth] = useState({});
  const [isSingleDateSelected, setIsSingleDateSelected] = useState(false);
  const [createActive, setCreateActive] = useState(false);
  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName: "",
    beneAccountId: "",
    bankAccountIFSC: "",
    bankAccountNo: "",
    categories: "",
    amount: "",
    settleType: "",
    bankLogo: "",
    pan: "",
    ownerId: null,
    ownerAccountName: "",
    ownerBankIFSC: null,
    ownerBankBalance: 0,
    ownerBankLogo: null,
    ownerLastUpdated: null,
    ownerBankAccountNo: null,
    selectedCategory: null,
    mergeCategory: null,
    amountInWords: "",
    prevImage: [],
    labels: [],
    ownerLabels: [],
  });
  const [categoryId, setCategoryId] = useState([]);
  //  useSelector
  const categories = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );

  //  Constants
  const steps = [
    "Destination account",
    "Category specific details",
    "Transfer amount",
    "Confirm and create",
  ];

  //  Callbacks

  const animationClass =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  //  useEffect
  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const handleKeyDown = useCallback((event) => {
    if (
      event.target.tagName !== "INPUT" &&
      event.target.tagName !== "TEXTAREA" &&
      (event.key === "ArrowLeft" || event.key === "ArrowRight")
    ) {
      event.preventDefault();
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  const handleCreateTransaction = async () => {
    setCreateActive(true);

    let haveImage = txnPayLoad?.mergeCategory?.some((val) => {
      return val?.data_type === "upload" && val?.value !== "Not Given";
    });

    let storeData;

    let add = 0;

    // const fileUpload = await dispatch(
    //   uploadFile({ file: txnPayLoad.uploadFile }),
    // );

    if (haveImage) {
      const responseUpload = await Promise.all(
        Object.values(uploadedFiles).map((file) =>
          dispatch(uploadFile({ file })),
        ),
      );
      if (responseUpload) {
        storeData = selectedCategory?.configuration?.data?.map((val) => {
          if (additionalData[val?.name]) {
            const dataValue = additionalData[val?.name];
            if (val?.data_type === "numeric") {
              const integerValue = parseInt(dataValue, 10);
              if (!isNaN(integerValue)) {
                return { ...val, value: integerValue };
              } else {
                throw new Error(
                  `Value '${dataValue}' is not a valid integer for category '${val?.name}'`,
                );
              }
            } else if (val?.data_type === "upload") {
              const { description, ...rest } = val;
              return { ...rest, value: responseUpload[add++]?.payload };
            } else if (val?.data_type === "from_year_to_year") {
              return {
                ...val,
                value: {
                  from: dataValue?.from ? Number(dataValue.from) : null,
                  to: dataValue?.to ? Number(dataValue.to) : null,
                },
              };
            } else if (val?.data_type === "toggle") {
              const { description, ...rest } = val;
              return { ...rest, value: dataValue };
            } else {
              return { ...val, value: dataValue };
            }
          } else if (val?.data_type === "toggle") {
            const { description, ...rest } = val;
            return { ...rest };
          }
          return val;
        });
      }
    } else {
      storeData = selectedCategory?.configuration?.data?.map((val) => {
        if (additionalData[val?.name]) {
          const dataValue = additionalData[val?.name];
          if (val?.data_type === "numeric") {
            const integerValue = parseInt(dataValue, 10);
            if (!isNaN(integerValue)) {
              return { ...val, value: integerValue };
            } else {
              throw new Error(
                `Value '${dataValue}' is not a valid integer for category '${val?.name}'`,
              );
            }
          } else if (val?.data_type === "from_year_to_year") {
            return {
              ...val,
              value: {
                from: dataValue?.from ? Number(dataValue.from) : null,
                to: dataValue?.to ? Number(dataValue.to) : null,
              },
            };
          } else if (val?.data_type === "toggle") {
            const { description, ...rest } = val;
            return { ...rest, value: dataValue };
          } else {
            return { ...val, value: dataValue };
          }
        } else if (val?.data_type === "toggle") {
          const { description, ...rest } = val;
          return { ...rest };
        }
        return val;
      });
    }

    const response1 = await dispatch(
      reimbursementTxnRequest({
        amount: txnPayLoad.amount,
        category: selectedCategory?.id,
        additional_data: storeData,
      }),
    );

    if (response1?.error?.message !== "Rejected") {
      let transactionId = response1.payload?.request[0]?.request_id;

      setCreateActive(false);
      navigate(
        `/reimbursement_transaction_dashboard/create_reimbursement_transactions/success/${transactionId}`,
        {
          replace: true,
        },
      );
    } else {
      navigate(
        "/reimbursement_transaction_dashboard/create_reimbursement_transactions/failed",
        {
          replace: true,
        },
      );

      setCreateActive(false);
    }
  };

  const handleNext = () => {
    if (activeStep === 1 && isCategoryLoading) return;

    if (activeStep === 3) {
      if (!createActive) {
        handleCreateTransaction();
      }
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);

      setDirection("next");
      setRemoveClassName(false);

      setTimeout(() => {
        setRemoveClassName(true);
      }, IntervalConfiguration?.intervalMedium);

      setTimeout(() => {}, IntervalConfiguration?.intervalSmaller);
    }
  };

  useEffect(() => {
    const handleEnterKeyPress = (e) => {
      if (e.key === "Enter" && activeStep === 3) {
        e.preventDefault();
        handleCreateTransaction();
      }
    };

    document.addEventListener("keydown", handleEnterKeyPress);
    return () => {
      document.removeEventListener("keydown", handleEnterKeyPress);
    };
  }, [activeStep, handleCreateTransaction]);

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[0],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled && !isCategoryLoading,
      stepperText: steps[1],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[2],
    },
    {
      previousText: "Previous",
      nextText: "Create",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--text-primary)",
      nextDisableBgColor: "var(--positive-act)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: createActive,
      nextLoaderNeeded: true,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[GlobalConfiguration.accountminLength],
    },
  ];

  const renderCreateTxn = () => {
    switch (activeStep) {
      case 0:
        return (
          <ReimbursementRequestAccount
            setCategoryIds={setCategoryId}
            catSelect={catSelect}
            setCatSelect={setCatSelect}
            mapingCat={mapingCat}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            handleCategorySelect={handleCategory}
            categories={categories}
            setAdditionalData={setAdditionalData}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            setSelectedValue={setSelectedValue}
            setSelectedValueMonth={setSelectedValueMonth}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            setStartDateCal={setStartDateCal}
            setIsSingleDateSelected={setIsSingleDateSelected}
            setQuantities={setQuantities}
            setAmountInWords={setAmountInWords}
            setHyperLink={setHyperLinks}
            setPreviewImages={setPreviewImages}
            setUploadedFiles={setUploadedFiles}
            setTimeData={setTimeData}
            setMapingCat={setMapingCat}
            setLabelsAcc={() => {}}
          />
        );
      case 1:
        return (
          <ReimbursementRequestTxnAdditionalDetails
            categoryIds={categoryId}
            catSelect={catSelect}
            setCatSelect={setCatSelect}
            categories={categories}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            handleCategorySelect={handleCategory}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            additionalData={additionalData}
            setAdditionalData={setAdditionalData}
            isCategoryLoading={isCategoryLoading}
            setIsCategoryLoading={setIsCategoryLoading}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            selectedValueMonth={selectedValueMonth}
            setSelectedValueMonth={setSelectedValueMonth}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            setShowDatePicker={() => {}}
            startDateCal={startDateCal}
            setStartDateCal={setStartDateCal}
            isSingleDateSelected={isSingleDateSelected}
            setIsSingleDateSelected={setIsSingleDateSelected}
            quantities={quantities}
            setQuantities={setQuantities}
            hyperLink={hyperLinks}
            setHyperLink={setHyperLinks}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            setPreviewImages={setPreviewImages}
            timeData={timeData}
            setTimeData={setTimeData}
            setQuantity={setQuantity}
            quantity={quantity}
            setShowYearDrop={setShowYearDrop}
            showYearDrop={showYearDrop}
          />
        );
      case 2:
        return (
          <ReimbursementRequestTxnTransferAmount
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            amountInWords={amountInWords}
            setAmountInWords={setAmountInWords}
          />
        );
      case 3:
        return (
          <ReimbursementRequestTxnConfirm
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            selectedCategory={selectedCategory}
            previewImages={previewImages}
            uploadedFiles={uploadedFiles}
          />
        );
      default:
        return null;
    }
  };

  const isValidHttpUrl = (url) => {
    const httpRegex =
      /^(https?:\/\/)([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(:[0-9]{1,5})?(\/.*)?$/;
    return httpRegex.test(url);
  };

  useEffect(() => {
    const configData = txnPayLoad?.selectedCategory?.configuration?.data || [];
    const mergeCategory = txnPayLoad?.mergeCategory || [];

    const mandatoryFields = configData.filter((val) => val?.mandatory === "Y");

    const isFieldFilled = (field) => {
      const match = mergeCategory.find((val) => val?.name === field?.name);
      if (!match) return false;

      if (field?.data_type === "from_year_to_year") {
        return !!(match?.value?.from && match?.value?.to);
      }
      if (field?.data_type === "date_range") {
        return !!(match?.value?.start_date && match?.value?.end_date);
      }
      if (
        field?.data_type === "multi_select_list" ||
        Array.isArray(match?.value)
      ) {
        return Array.isArray(match?.value) && match.value.length > 0;
      }

      return !!match?.value;
    };

    const isMandatoryFieldsFilled = mandatoryFields.every(isFieldFilled);

    const isHyperlinkHave = mergeCategory?.some(
      (val) => val?.data_type === "hyperlink",
    );

    const isHyperlinkvalid = mergeCategory
      ?.filter((val) => {
        return val?.data_type === "hyperlink" && val?.value !== "";
      })
      .every((val) => isValidHttpUrl(val?.value));

    const isHyperLink = isHyperlinkHave && isHyperlinkvalid;

    const isAmountValid = txnPayLoad?.amount > 0;

    let isStepValid = false;

    switch (activeStep) {
      case 0:
        isStepValid = !!txnPayLoad?.beneAccountId;
        break;

      case 1:
        isStepValid =
          isMandatoryFieldsFilled &&
          (!isHyperlinkHave || isHyperLink) &&
          !!txnPayLoad?.selectedCategory;
        break;

      case 2:
        isStepValid = isAmountValid;
        break;

      case 3:
        isStepValid = true;
        break;
      default:
        break;
    }
    BenEnableNextButton(!isStepValid);
  }, [activeStep, txnPayLoad, hyperLinks]);

  const handleBack = () => {
    if (activeStep === GlobalConfiguration?.lengthCheckZero) {
      navigate(GlobalConfiguration?.navigate_back);
      return;
    } else {
      setActiveStep((prevActiveStep) =>
        prevActiveStep
          ? prevActiveStep - GlobalConfiguration?.lengthCheckOne
          : GlobalConfiguration?.lengthCheckZero,
      );

      setDirection("previous");

      setRemoveClassName(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, 1000);
      setTimeout(() => {}, 500);
      // setTxnPayLoad((x) => {
      //   return {
      //     ...x,
      //     expenseType: undefined,
      //     date: undefined,
      //     uploadFile: undefined,
      //     description: undefined,
      //   };
      // });
    }
  };
  useEffect(() => {
    if (
      location?.state?.txnDetails?.reminderAmount !== "" &&
      txnPayLoad?.amount === "" &&
      location?.state !== null
    ) {
      let amountWords =
        AmountToWords(
          parseFloat(location?.state?.txnDetails?.reminderAmount),
        ) || "";
      setAmountInWords(
        location?.state?.txnDetails?.reminderAmount >= 1 &&
          location?.state?.txnDetails?.reminderAmount <= 9
          ? amountWords.replace("rupees", "rupee")
          : amountWords,
      );
      setTxnPayLoad((prev) => {
        return {
          ...prev,
          amount: location?.state?.txnDetails?.reminderAmount,
          amountInWords:
            location?.state?.txnDetails?.reminderAmount >= 1 &&
            location?.state?.txnDetails?.reminderAmount <= 9
              ? amountWords.replace("rupees", "rupee")
              : amountWords,
        };
      });
    }
  }, [location]);
  const handleCategory = (selectedCategoryData) => {
    setSelectedCategory(selectedCategoryData);
  };

  const [isStepper, setIsStepper] = useState(window.innerWidth <= 800);

  useEffect(() => {
    const handleResize = () => {
      setIsStepper(window.innerWidth <= 800);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  const [uploadedFiles, setUploadedFiles] = useState({});
  const [previewImages, setPreviewImages] = useState({});

  useEffect(() => {
    scrollIt.current.scrollTop = GlobalConfiguration?.lengthCheckZero;
  }, [activeStep]);

  const handleEnterKeyPress = useCallback(
    (e) => {
      if (e.key !== "Enter") return;

      e.preventDefault();
      e.stopPropagation();

      if (
        activeStep === GlobalConfiguration.lengthCheckZero &&
        !nextButtonEnabled
      ) {
        handleNext();
        return;
      } else if (
        activeStep === GlobalConfiguration.lengthCheckOne &&
        !nextButtonEnabled
      ) {
        handleNext();
        return;
      } else if (
        activeStep === GlobalConfiguration.lengthCheckTwo &&
        !nextButtonEnabled
      ) {
        handleNext();
        return;
      } else if (activeStep === GlobalConfiguration.lengthCheckThree) {
        if (!createActive) {
          handleCreateTransaction();
        }
        return;
      }
    },
    [activeStep, handleNext],
  );

  useEffect(() => {
    document.addEventListener("keydown", handleEnterKeyPress);
    return () => {
      document.removeEventListener("keydown", handleEnterKeyPress);
    };
  }, [handleEnterKeyPress]);

  return (
    <div
      className="w-width-full flex justify-start items-center flex-col bg-primary-bg overflow-y-auto"
      style={{
        height: false ? "var(--height-full)" : "var(--full-height)",
      }}
    >
      <div className="w-width-full hidden Qsmd:block h-navbar-breadcrumb-height Qlg:bg-transparent bg-primary-nav flex-shrink-0"></div>
      <div className="bene_crt_reminder_header left-left-base z-z-index-loader flex justify-center items-center flex-col lg:flex-col-reverse w-width-full lg:py-padding-base bottom-bottom-base top-auto lg:top-top-base lg:bottom-auto  Qsmd:bg-transparent">
        <PrimaryStepper
          activeStep={activeStep}
          handleForwardAction={handleNext}
          handleBackwardAction={handleBack}
          dataArray={dataArray}
        />
      </div>

      {isStepper && (
        <>
          <div className="flex items-center w-full-width h-mobile-create-header bg-primary-nav p-padding-md top-top-base z-z-index-header shadow-box-shadow-bottom">
            <div
              className="cursor-pointer"
              onClick={() => {
                if (activeStep === 0) {
                  navigate("/reimbursement_transaction_dashboard");
                } else {
                  navigate(-1);
                }
              }}
            >
              <SVGComponent
                url={ICONS?.ARROW_LEFT_WHITE}
                color={"var(--text-primary)"}
                height={"var(--icon-md)"}
                width={"var(--icon-md)"}
                alt="Arrow"
              />
            </div>
            <div className="flex flex-col ml-margin-md">
              <div className="text-text-primary text-base">
                Reimbursement request
              </div>

              <>
                <div className="text-text-secondary text-xs">
                  {steps[activeStep] || ""}
                </div>
              </>
            </div>
          </div>
        </>
      )}

      <div className="overflow-y-auto overflow-x-hidden w-width-full h-height-full">
        <div className="mx-auto overflow-x-hidden overflow-y-auto h-full flex flex-1 flex-col items-center relative w-width-full no-scrollbar">
          <>
            <div
              ref={scrollIt}
              className={`flex flex-1 w-width-full ${
                activeStep === GlobalConfiguration.lengthCheckZero &&
                direction === "next"
                  ? ""
                  : removeClassName === true
                    ? ""
                    : animationClass
              }`}
            >
              {renderCreateTxn()}
            </div>
          </>
        </div>
      </div>

      <div className="h-stepper-moble-height block Qmd:hidden"></div>
    </div>
  );
};

export default ReimbursementTxnRequestCreate;
